// Sizes according to -> http://getbootstrap.com/css/#grid-media-queries which is grid system VX inherits

export const SIZE_GREY_BACKGROUND = 550
export const SIZE_MOBILE = 480
export const SIZE_EXTRA_SMALL = 393
export const SIZE_SMALL = 768
export const SEARCH_INPUT_WIDTH = 667
export const SIZE_MEDIUM = 992
export const SIZE_LARGE = 1200

// Mobile-first Queries (think smallest first, add media queries to support larger devices):
export const smallAndBigger = `@media only screen and (min-width: ${SIZE_SMALL}px)`
export const biggerThanSmall = `@media only screen and (min-width: ${SIZE_SMALL +
  1}px)`
export const mediumAndBigger = `@media only screen and (min-width: ${SIZE_MEDIUM}px)`
export const largeAndBigger = `@media only screen and (min-width: ${SIZE_LARGE}px)`

// Desktop-first Queries (think largest first, add media queries to support smaller devices):
export const mobileAndSmaller = `@media only screen and (max-width: ${SIZE_MOBILE}px)`
export const greyBackgroundAndSmaller = `@media only screen and (max-width: ${SIZE_GREY_BACKGROUND}px)`
export const extraSmallAndSmaller = `@media only screen and (max-width: ${SIZE_EXTRA_SMALL}px)`
export const smallAndSmaller = `@media only screen and (max-width: ${SIZE_SMALL}px)`
export const mediumAndSmaller = `@media only screen and (max-width: ${SIZE_MEDIUM}px)`
export const largeAndSmaller = `@media only screen and (max-width: ${SIZE_LARGE}px)`
export const searchInputWithSmallAndSmaller = `@media only screen and (max-width: ${SEARCH_INPUT_WIDTH}px)`
